import * as React from 'react';
import classnames from 'classnames';

const ModalTitle: React.SFC<any> = (props) => {
    const { children, className, ...attributes } = props;
    return (
        <div
            className={classnames('modal-title', {
                className
            })}
            {...attributes}
        >
            {children}
        </div>
    );
};

export default ModalTitle;
